/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  addressTemplateRouterSegment,
  adminOwnershipRequestListSegment,
  anafMessagesRouterSegment,
  blockCustomerRouterSegment,
  blockVendorRouterSegment,
  budgetManagementSegment,
  cashFlowRouterSegment,
  cashFlowTransactionsRouterSegment,
  contractCancelRequestRouterSegment,
  contractManagementRouterSegment,
  contractOrderRouterSegment,
  contractRejectRouterSegment,
  contractsCustomerRouterSegment,
  contractsRouterSegment,
  contractsSpRouterSegment,
  costCenterEditRouterSegment,
  costCenterManageRouterSegment,
  costCenterNewRouterSegment,
  costCenterRouterSegment,
  costCenterScheduledShipmentManageRouterSegment,
  costCenterShipmentManageRouterSegment,
  costCenterShipmentRequestManageRouterSegment,
  costCenterSpManageRouterSegment,
  costRouterSegment,
  courierEditRouterSegment,
  courierManagementRouterSegment,
  customerBlacklistHistoryRouterSegment,
  customerOfferRequestCancelRouterSegment,
  customerOfferRequestDetailsRouterSegment,
  customerOfferRequestNewRouterSegment,
  customerOfferRequestRouterSegment,
  customerOfferRequestSubcontractingRouterSegment,
  customerOrderCancelRequestRouterSegment,
  customerOrderComplaintsRouterSegment,
  customerOrderDetailsRouterSegment,
  customerOrderRouterSegment,
  customerPreOfferRequestRouterSegment,
  customersRouterSegment,
  deliveryInboxRouterSegment,
  deliveryRouterSegment,
  dispatcherRouterSegment,
  dispatcherTaskRouterSegment,
  dispatcherTasksRouterSegment,
  dispatcherTasksRoutesRouterSegment,
  driverAddRouterSegment,
  driverDetailsRouterSegment,
  driverDocumentSidebar,
  driverEditRouterSegment,
  driverExpenseRouterSegment,
  driverIdentityDocumentPopup,
  driverLicensePopup,
  driverManagementRouterSegment,
  driverTimesheetRouterSegment,
  editRouterSegment,
  eFacturaRouterSegment,
  etransportActionsListRouterSegment,
  etransportActionsRouterSegment,
  etransportAddRouterSegment,
  eTransportConfirmationRouterSegment,
  eTransportDeclarantRouterSegment,
  etransportDetailsRouterSegment,
  etransportDuplicateRouterSegment,
  etransportEditRouterSegment,
  etransportListRouterSegment,
  etransportModifVehicleRouterSegment,
  eTransportOrganizerRouterSegment,
  etransportRouterSegment,
  externalMappingsAddRouterSegment,
  externalMappingsEditRouterSegment,
  externalMappingsHubLocationRouterSegment,
  externalMappingsLegalEntityRouterSegment,
  externalMappingsLocationRouterSegment,
  externalMappingsPackageRouterSegment,
  externalMappingsRouterSegment,
  externalVendorAccountNumberNewRouterSegment,
  externalVendorAccountNumberRouterSegment,
  fromTemplateRouterSegment,
  groupsRouterSegment,
  hubOrderRouterSegment,
  hubTaskManagementRouterSegment,
  internalOrderRouterSegment,
  invoiceChangeDueDateRouterSegment,
  invoiceCustomer,
  invoiceCustomerNew,
  invoiceCustomerRouterSegment,
  invoiceDetailsRouterSegment,
  invoicePaymentRouterSegment,
  invoiceRejectSegment,
  invoiceReportRouterSegment,
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  listRouterSegment,
  markAsPaidSegment,
  namedLocationAddFromExtractionRouterSegment,
  namedLocationAddRouterSegment,
  namedLocationListRouterSegment,
  namedLocationManagementRouterSegment,
  namedLocationRouterSegment,
  newPaymentPerInvoiceRouterSegment,
  newPaymentRouterSegment,
  newRouterSegment,
  nomenclatureAddRouterSegment,
  nomenclatureEditRouterSegment,
  nomenclatureListRouterSegment,
  nomenclatureRouterSegment,
  notifiableContactEditRouterSegment,
  notifiableContactRouterSegment,
  offerRefuseRouterSegment,
  offerRequestRouterSegment,
  offerRouterSegment,
  offerUpdateRouterSegment,
  operationalTerritoryAddRouterSegment,
  operationalTerritoryEditRouterSegment,
  operationalTerritoryRouterSegment,
  orderAcceptRouterSegment,
  orderCancelRequestRouterSegment,
  orderManagementRouterSegment,
  orderNewRouterSegment,
  orderRefuseRouterSegment,
  orderSegmentSubcontractingRouterSegment,
  orderShipperAndPaymentPartiesManagementUrl,
  orderStatusHistoryRouterSegment,
  orderSubcontractingRouterSegment,
  orderTrackingRouterSegment,
  ownershipRequestAddSegment,
  ownershipRequestDetailsSegment,
  ownershipRequestListSegment,
  ownershipRequestRouterSegment,
  paymentCancelSegment,
  paymentDeallocateSegment,
  paymentRejectSegment,
  preOrderRouterSegment,
  routedOrderTemplateAddRouterSegment,
  routedOrderTemplateEditRouterSegment,
  routedOrderTemplateRouterSegment,
  routeShareLocation,
  routeShareLocationDetailsRouterSegment,
  routeShareLocationNewRouterSegment,
  scheduledShipmentRouterSegment,
  scheduledShipmentsRouterSegment,
  sentRouteShareLocationSegment,
  serviceProviderOrderCancelRequestRouterSegment,
  shipmentDraftsOrderRouterSegment,
  shipmentDraftsTaskManagementRouterSegment,
  shipmentGroupConsolidationRouterSegment,
  shipmentGroupSolutionsRouterSegment,
  shipmentSplitRouterSegment,
  shipmentTemplateRouterSegment,
  shipmentTimelineRouterSegment,
  spOfferRequestDetailsRouterSegment,
  spOfferRequestAiNewRouterSegment,
  spOfferRequestNewRouterSegment,
  spOfferRequestRouterSegment,
  spOrderComplaintsRouterSegment,
  spOrderDetailsRouterSegment,
  spOrderDetailsStatusRouterSegment,
  spOrderRouterSegment,
  standardPackageDimensionRouterSegment,
  supplierDelegationRouterSegment,
  supplierOrderRouterSegment,
  taskListRouterSegment,
  taskManagementDefaultRouterSegment,
  taskManagementDetailsRouterSegment,
  taskManagementNewRouterSegment,
  taskManagementRouterSegment,
  transportProjectAddRouterSegment,
  transportProjectEditRouterSegment,
  transportProjectRouterSegment,
  transportProjectScheduledRouterSegment,
  unedifactListRouterSegment,
  unedifactRouterSegment,
  vehicleAddRouterSegment,
  vehicleDetailsRouterSegment,
  vehicleDisableEquipmentRouterSegment,
  vehicleDocumentSidebar,
  vehicleEditRouterSegment,
  vehicleEquipmentSidebar,
  vehicleFuelCardSidebar,
  vehicleInstallEquipmentRouterSegment,
  vehicleManagementRouterSegment,
  vehicleTransferRouterSegment,
  vendorBlacklistHistoryRouterSegment,
  vendorRouterSegment,
  warehousesReservationListRouterSegment,
  warehousesCreateRouterSegment,
  warehousesRouterSegment,
  warehousesTerminalsRouterSegment,
  externalVendorDiscountRouterSegment,
  externalVendorDiscountNewRouterSegment,
  costCenterShipmentTemplateManageRouterSegment,
  hubRoutingRouterSegment
} from './navigation-constants';

export const workspaceUrl = ['/', deliveryRouterSegment];

export const customerOfferRequestListUrl = [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  customerOfferRequestRouterSegment
];
export const customerOfferRequestNewUrl = [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  customerOfferRequestRouterSegment,
  customerOfferRequestNewRouterSegment
];

export const customerPreOfferRequestSubcontractingDialogNewUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        offerRequestRouterSegment,
        customerOfferRequestRouterSegment,
        customerPreOfferRequestRouterSegment,
        customerOfferRequestSubcontractingRouterSegment,
        uuid
      ],
    },
  }
];

export const customerOfferRequestSubcontractingDialogNewUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        offerRequestRouterSegment,
        customerOfferRequestRouterSegment,
        customerOfferRequestSubcontractingRouterSegment,
        uuid
      ],
    },
  }
];

export const customerOrderSegmentSubcontractingDialogNewUrl = (shipmentGroupUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        orderManagementRouterSegment,
        contractOrderRouterSegment,
        orderSegmentSubcontractingRouterSegment,
        shipmentGroupUuid
      ],
    },
  }
];

export const customerPreOrderSegmentSubcontractingDialogNewUrl = (shipmentGroupUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        orderManagementRouterSegment,
        contractOrderRouterSegment,
        preOrderRouterSegment,
        orderSegmentSubcontractingRouterSegment,
        shipmentGroupUuid
      ],
    },
  }
];

export const customerOfferRequestDetailUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  customerOfferRequestRouterSegment,
  customerOfferRequestDetailsRouterSegment,
  uuid
];
export const customerOfferRequestDetailPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        offerRequestRouterSegment,
        customerOfferRequestRouterSegment,
        customerOfferRequestDetailsRouterSegment,
        uuid
      ],
    },
  }
];
export const customerOfferRequestCancelPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        offerRequestRouterSegment,
        customerOfferRequestRouterSegment,
        customerOfferRequestCancelRouterSegment,
        uuid
      ],
    },
  }
];

export const offerRefuseUrl = (uuid: any) => [
  '/',
  { outlets: { popup: ['popup', deliveryRouterSegment, 's', offerRouterSegment, offerRefuseRouterSegment, uuid] } }
];

export const customerOfferRequestDetailSideUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      'right-side': [
        'right-side',
        deliveryRouterSegment,
        's',
        offerRequestRouterSegment,
        customerOfferRequestRouterSegment,
        customerOfferRequestDetailsRouterSegment,
        uuid
      ],
    },
  }
];

export const spOfferRequestListUrl = [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  spOfferRequestRouterSegment
];
export const spOfferRequestNewUrl = [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  spOfferRequestRouterSegment,
  spOfferRequestNewRouterSegment
];
export const spOfferRequestAiNewUrl = (extractionUuid: string) => [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  spOfferRequestRouterSegment,
  spOfferRequestAiNewRouterSegment,
  extractionUuid,
];
export const spOfferRequestDetailUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  offerRequestRouterSegment,
  spOfferRequestRouterSegment,
  spOfferRequestDetailsRouterSegment,
  uuid
];

export const offerOrderNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, orderNewRouterSegment];
export const contractOrderNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, contractOrderRouterSegment, orderNewRouterSegment];
export const contractOrderFromHubNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, contractOrderRouterSegment, hubOrderRouterSegment, orderNewRouterSegment];
export const contractOrderFromShipmentDraftsNewUrl = (shipmentDraftUuids: string[]) =>  ['/', deliveryRouterSegment, orderManagementRouterSegment, contractOrderRouterSegment, shipmentDraftsOrderRouterSegment, orderNewRouterSegment, shipmentDraftUuids.join(',')];
export const internalOrderNewUrl = [
  '/',
  deliveryRouterSegment,
  orderManagementRouterSegment,
  contractOrderRouterSegment,
  internalOrderRouterSegment,
  orderNewRouterSegment
];
export const supplierOrderNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, supplierOrderRouterSegment];
export const offerPreOrderNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, preOrderRouterSegment, orderNewRouterSegment];
export const contractPreOrderNewUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, contractOrderRouterSegment, preOrderRouterSegment, orderNewRouterSegment];

export const customerOrderCancelRequestPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', orderManagementRouterSegment, orderCancelRequestRouterSegment, customerOrderCancelRequestRouterSegment, uuid],
    },
  }
];

export const serviceProviderOrderCancelRequestPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', orderManagementRouterSegment, orderCancelRequestRouterSegment, serviceProviderOrderCancelRequestRouterSegment, uuid],
    },
  }
];

export const contractCancelRequestPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        contractManagementRouterSegment,
        contractCancelRequestRouterSegment,
        uuid
      ],
    },
  }
];

export const orderAcceptPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', orderManagementRouterSegment, orderAcceptRouterSegment, uuid],
    },
  }
];

export const orderRefusePopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', orderManagementRouterSegment, orderRefuseRouterSegment, uuid],
    },
  }
];

export const orderStatusHistoryPopupUrl = (uuid: any) => [
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        orderManagementRouterSegment,
        orderStatusHistoryRouterSegment,
        uuid
      ],
    },
  }
];

export const customerOrderListUrl = [
  '/',
  deliveryRouterSegment,
  orderManagementRouterSegment,
  customerOrderRouterSegment
];
export const customerOrderDetailUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  orderManagementRouterSegment,
  customerOrderRouterSegment,
  customerOrderDetailsRouterSegment,
  uuid
];
export const customerOrderComplaint = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  customerOrderRouterSegment,
  customerOrderComplaintsRouterSegment,
  uuid
];

export const spShipmentsResumeUrl = (orderUuid: string, shipmentUuid?: string) => [
  '/',
  {
    outlets: {
      'popup-full': shipmentUuid
        ? ['popup-full', deliveryRouterSegment, 's', 'shipment', 'sp', 'resume', orderUuid, shipmentUuid]
        : ['popup-full', deliveryRouterSegment, 's', 'shipment', 'sp', 'resume', orderUuid],
    },
  }
];

export const customerShipmentsResumeUrl = (orderUuid: string, shipmentUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': ['popup-full', deliveryRouterSegment, 's', 'shipment', 'customer', 'resume', orderUuid, shipmentUuid],
    },
  }
];

export const spOrderListUrl = ['/', deliveryRouterSegment, orderManagementRouterSegment, spOrderRouterSegment];
export const spOrderListRelativeUrl = [orderManagementRouterSegment, spOrderRouterSegment];
export const spOrderDetailUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  orderManagementRouterSegment,
  spOrderDetailsRouterSegment,
  uuid
];
export const spOrderDetailStatusUrl = (orderUuid: any, spOrderUuid: any) => [
  '/',
  deliveryRouterSegment,
  spOrderRouterSegment,
  spOrderDetailsRouterSegment,
  orderUuid,
  spOrderDetailsStatusRouterSegment,
  spOrderUuid
];
export const spOrderComplaint = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  spOrderRouterSegment,
  spOrderComplaintsRouterSegment,
  uuid
];
export const spOrderCreation = ['/', deliveryRouterSegment, orderManagementRouterSegment, 'new'];

export const shipmentSplitUrl = (shipmentGroupUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentSplitRouterSegment,
  shipmentGroupUuid
];
export const shipmentGroupSolutionsUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentSplitRouterSegment,
  shipmentGroupSolutionsRouterSegment,
  uuid
];
export const shipmentGroupSolutionsRelativeUrl = (uuid: any) => [shipmentGroupSolutionsRouterSegment, uuid];
export const shipmentSplitRelativeUrl = (uuid: any) => [shipmentSplitRouterSegment, uuid];

export const addressTemplateListUrl = ['/', deliveryRouterSegment, addressTemplateRouterSegment];

export const shipmentTimelineOfferRequestUrl = (timelineUuid: any, offerRequestUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  offerRequestRouterSegment,
  spOfferRequestRouterSegment,
  spOfferRequestDetailsRouterSegment,
  offerRequestUuid
];

export const shipmentTimelineOrderUrl = (timelineUuid: any, orderUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  orderManagementRouterSegment,
  spOrderDetailsRouterSegment,
  orderUuid
];

export const shipmentTimelineSplitUrl = (timelineUuid: any, shipmentGroupUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  shipmentSplitRouterSegment,
  shipmentGroupUuid
];

export const shipmentTimelineConsolidationUrl = (timelineUuid: string) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  shipmentGroupConsolidationRouterSegment
];

export const shipmentTimelineLatestSolutionUrl = (timelineUuid: any, latestSolutionUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  shipmentSplitRouterSegment,
  shipmentGroupSolutionsRouterSegment,
  latestSolutionUuid
];

export const relativeShipmentTimelineLatestSolutionUrl = (timelineUuid: any, latestSolutionUuid: any) => [
  '../../..',
  shipmentSplitRouterSegment,
  shipmentGroupSolutionsRouterSegment,
  latestSolutionUuid
];

export const shipmentTimelineCustomerOfferRequestUrl = (timelineUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  offerRequestRouterSegment,
  customerOfferRequestRouterSegment,
  customerOfferRequestNewRouterSegment
];

export const shipmentTimelineCustomerPreOfferRequestSubcontractingUrl = (timelineUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  offerRequestRouterSegment,
  customerOfferRequestRouterSegment,
  customerPreOfferRequestRouterSegment,
  customerOfferRequestNewRouterSegment
];

export const shipmentTimelineCustomerOrderSubcontractingUrl = (timelineUuid: string, shipmentGroupUuid: string) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  orderManagementRouterSegment,
  contractOrderRouterSegment,
  orderSubcontractingRouterSegment,
  shipmentGroupUuid
];

export const shipmentTimelineCustomerPreOrderSubcontractingUrl = (timelineUuid: string, shipmentGroupUuid: string) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  orderManagementRouterSegment,
  contractOrderRouterSegment,
  preOrderRouterSegment,
  orderSubcontractingRouterSegment,
  shipmentGroupUuid
];

export const shipmentTimelineOrderTrackingUrl = (timelineUuid: any, orderUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  orderTrackingRouterSegment,
  spOrderDetailsRouterSegment,
  orderUuid
];

export const shipmentTimelineInvoiceUrl = (timelineUuid: any, invoiceUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  invoiceDetailsRouterSegment,
  invoiceUuid
];

export const shipmentTimelineInvoiceOrderListUrl = (timelineUuid: any) => [
  '/',
  deliveryRouterSegment,
  shipmentTimelineRouterSegment,
  timelineUuid,
  orderManagementRouterSegment,
  spOrderRouterSegment
];

export const updateOfferDriverPopupUrl = (uuid: any) => [
  '/',
  { outlets: { popup: ['popup', deliveryRouterSegment, 's', offerRouterSegment, offerUpdateRouterSegment, uuid] } }
];

export const invoiceDetailUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceDetailsRouterSegment,
  uuid
];
export const spInvoiceDetailUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  invoiceDetailsRouterSegment,
  uuid
];
export const spInvoiceDetailPath = [
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  invoiceDetailsRouterSegment
].join('/');
export const spInvoiceListPath = [deliveryRouterSegment, invoiceRouterSegment, invoiceSpRouterSegment].join('/');
export const customerInvoiceDetailUrl = (uuid: any) => [
  '/',
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceCustomerRouterSegment,
  invoiceDetailsRouterSegment,
  uuid
];
export const customerInvoiceDetailPath = [
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceCustomerRouterSegment,
  invoiceDetailsRouterSegment
].join('/');
export const customerInvoiceListPath = [deliveryRouterSegment, invoiceRouterSegment, invoiceCustomerRouterSegment].join('/');
export const spInvoiceDetailRelativeUrl = (uuid: any) => [
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  invoiceDetailsRouterSegment,
  uuid
];
export const spInvoiceListRelativeUrl = [invoiceRouterSegment, invoiceSpRouterSegment];

export const customerInvoiceListRelativeUrl = [invoiceRouterSegment, invoiceCustomerRouterSegment];

export const spInvoiceChangeDueDatePopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoiceRouterSegment,
        invoiceSpRouterSegment,
        invoiceChangeDueDateRouterSegment,
        uuid
      ],
    },
  }
];

export const customerInvoiceChangeDueDatePopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoiceRouterSegment,
        invoiceCustomer,
        invoiceChangeDueDateRouterSegment,
        uuid
      ],
    },
  }
];

export const customerInvoiceNewUrl = [
  '/',
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceCustomer,
  invoiceCustomerNew
];
export const spInvoiceNewUrl = [
  '/',
  deliveryRouterSegment,
  invoiceRouterSegment,
  invoiceSpRouterSegment,
  invoiceCustomerNew
];

export const eFacturaListUrl = ['/', deliveryRouterSegment, eFacturaRouterSegment, listRouterSegment];
export const anafMessagesUrl = [
  '/',
  deliveryRouterSegment,
  eFacturaRouterSegment,
  anafMessagesRouterSegment,
  listRouterSegment
];

export const deliveryInboxUrl = ['/', deliveryRouterSegment, deliveryInboxRouterSegment];

export const paymentPerInvoicePopupUrl = (uuid: any, selectedCurrencyCode: string | null) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoicePaymentRouterSegment,
        newPaymentPerInvoiceRouterSegment,
        uuid,
        selectedCurrencyCode
      ],
    },
  }
];

export const reportPerCustomerInvoicePopupUrl = (invoiceUuids: any, currencyCode: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoiceRouterSegment,
        invoiceCustomer,
        invoiceReportRouterSegment,
        invoiceUuids,
        currencyCode
      ],
    },
  }
];

export const paymentPerCustomerInvoicePopupUrl = (uuid: any, selectedCurrencyCode: string | null) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoicePaymentRouterSegment,
        newPaymentPerInvoiceRouterSegment,
        invoiceCustomer,
        uuid,
        selectedCurrencyCode
      ],
    },
  }
];

export const markAsPaidInvoicePopupUrl = (uuid: any, currencyCode: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoicePaymentRouterSegment,
        newPaymentPerInvoiceRouterSegment,
        markAsPaidSegment,
        uuid,
        currencyCode
      ],
    },
  }
];

export const markAsPaidCustomerInvoicePopupUrl = (uuid: any, currencyCode: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoicePaymentRouterSegment,
        newPaymentPerInvoiceRouterSegment,
        markAsPaidSegment,
        invoiceCustomer,
        uuid,
        currencyCode
      ],
    },
  }
];

export const paymentPopupUrl = (invoicesUuids: any, remainingAmount: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoicePaymentRouterSegment,
        newPaymentRouterSegment,
        invoicesUuids,
        remainingAmount
      ],
    },
  }
];
export const notifiableContactEditPopupUrl = (
  context: any,
  abstractNotifiableEntityUuid: string,
  businessProfileUuids: string[]
) => {
  const businessProfileUuidsParam = businessProfileUuids.join(',');

  return [
    '/',
    {
      outlets: {
        popup: [
          'popup',
          deliveryRouterSegment,
          's',
          notifiableContactRouterSegment,
          context,
          notifiableContactEditRouterSegment,
          abstractNotifiableEntityUuid,
          businessProfileUuidsParam
        ],
      },
    }
  ];
};

export const paymentCancelPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: { popup: ['popup', deliveryRouterSegment, 's', invoicePaymentRouterSegment, paymentCancelSegment, uuid] },
  }
];

export const paymentDeallocatePopupUrl = (type: any, uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', invoicePaymentRouterSegment, paymentDeallocateSegment, type, uuid],
    },
  }
];

export const paymentRejectPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: { popup: ['popup', deliveryRouterSegment, 's', invoicePaymentRouterSegment, paymentRejectSegment, uuid] },
  }
];

export const spRejectInvoicePopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        invoiceRouterSegment,
        invoiceSpRouterSegment,
        invoiceRejectSegment,
        uuid
      ],
    },
  }
];

export const customerRejectInvoicePopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', invoiceRouterSegment, invoiceCustomer, invoiceRejectSegment, uuid],
    },
  }
];

export const sPContractsList = ['/', deliveryRouterSegment, contractsRouterSegment, contractsSpRouterSegment];
export const sPContractsEdit = (uuid: any) => [...sPContractsList, 'edit', uuid];
export const sPContractsDetail = (uuid: any) => [...sPContractsList, 'detail', uuid];
export const spContractsNew = (uuid: any) => [...sPContractsList, 'new', uuid];

export const customerContractsList = [
  '/',
  deliveryRouterSegment,
  contractsRouterSegment,
  contractsCustomerRouterSegment
];

export const customerContractAddUrl = [...customerContractsList, 'new'];
export const customerContractResponseUrl = (uuid: any) => [...customerContractsList, 'response', uuid];
export const customerContractEditUrl = (uuid: any) => [...customerContractsList, 'edit', uuid];
export const contractRejectPopupUrl = (uuid: any) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        contractsRouterSegment,
        contractsSpRouterSegment,
        contractRejectRouterSegment,
        uuid
      ],
    },
  }
];

export const dispatcherScheduledShipmentManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', dispatcherRouterSegment, scheduledShipmentRouterSegment, uuid],
    },
  }
];

export const dispatcherTaskRoutesDetailUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  dispatcherTasksRouterSegment,
  dispatcherTasksRoutesRouterSegment,
  uuid
];

export const costCenterList = ['/', deliveryRouterSegment, costCenterRouterSegment];
export const costCenterAddPopup = [
  '/',
  { outlets: { popup: ['popup', deliveryRouterSegment, 's', costCenterRouterSegment, costCenterNewRouterSegment] } }
];
export const costCenterEditPopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', costCenterRouterSegment, costCenterEditRouterSegment, uuid],
    },
  }
];
export const costCenterShipmentRequestManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterManageRouterSegment,
        costCenterShipmentRequestManageRouterSegment,
        uuid
      ],
    },
  }
];
export const costCenterShipmentManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterManageRouterSegment,
        costCenterShipmentManageRouterSegment,
        uuid
      ],
    },
  }
];
export const costCenterScheduledShipmentManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterManageRouterSegment,
        costCenterScheduledShipmentManageRouterSegment,
        uuid
      ],
    },
  }
];
export const costCenterShipmentTemplateManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterManageRouterSegment,
        costCenterShipmentTemplateManageRouterSegment,
        uuid
      ],
    },
  }
];

export const costCenterSpShipmentRequestManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterSpManageRouterSegment,
        costCenterShipmentRequestManageRouterSegment,
        uuid
      ],
    },
  }
];
export const costCenterSpShipmentManagePopup = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        costCenterRouterSegment,
        costCenterSpManageRouterSegment,
        costCenterShipmentManageRouterSegment,
        uuid
      ],
    },
  }
];

export const costListUrl = ['/', deliveryRouterSegment, costRouterSegment];
export const costAddUrl = [...costListUrl, newRouterSegment];
export const costEditUrl = (uuid: string) => [...costListUrl, 'edit', uuid];

export const standardPackageDimensionsUrl = ['/', deliveryRouterSegment, standardPackageDimensionRouterSegment];
export const dispatcherTaskRoutesOverviewUrl = [
  '/',
  deliveryRouterSegment,
  dispatcherTasksRouterSegment,
  dispatcherTasksRoutesRouterSegment
];

export const dispatcherTaskStatusChangeUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        dispatcherTasksRouterSegment,
        dispatcherTasksRoutesRouterSegment,
        dispatcherTaskRouterSegment,
        uuid
      ],
    },
  }
];

export const taskListUrl = [
  '/',
  deliveryRouterSegment,
  dispatcherTasksRouterSegment,
  taskListRouterSegment
];

export const taskAddPopup = (routingSolutionUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        taskManagementNewRouterSegment,
        routingSolutionUuid
      ],
    },
  }
];

export const hubDraftTaskAddPopup = (routedOrderTemplateDraftUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        hubTaskManagementRouterSegment,
        'draft',
        routedOrderTemplateDraftUuid,
      ],
    },
  }
];

export const hubTaskAddPopup = (routedOrderTemplateUuid: string, shipmentDraftUuids: string[]) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        hubTaskManagementRouterSegment,
        routedOrderTemplateUuid,
        shipmentDraftUuids.join(',')
      ],
    },

  }
];

export const shipmentDraftsTaskAddPopup = (shipmentDraftUuids: string[]) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        shipmentDraftsTaskManagementRouterSegment,
        shipmentDraftUuids.join(',')
      ],
    },

  }
];

export const defaultTaskAddPopup = (shipmentGroupUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        taskManagementDefaultRouterSegment,
        shipmentGroupUuid
      ],
    },

  }
];

export const taskDetailsPopup = (taskUuid: string) => [
  '/',
  {
    outlets: {
      'popup': [
        'popup',
        deliveryRouterSegment,
        's',
        taskManagementRouterSegment,
        taskManagementDetailsRouterSegment,
        taskUuid
      ],
    },
  }
];

export const vehicleEditEquipment = (vehicleUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleEquipmentSidebar,
        vehicleEditRouterSegment,
        vehicleUuid,
        uuid
      ],
    },
  }
];
export const vehicleAddEquipment = (vehicleUuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleEquipmentSidebar,
        vehicleAddRouterSegment,
        vehicleUuid
      ],
    },
  }
];

export const vehicleDisableEquipment = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleDisableEquipmentRouterSegment,
        uuid
      ],
    },
  }
];
export const vehicleInstallEquipment = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleInstallEquipmentRouterSegment,
        uuid
      ],
    },
  }
];

export const vehicleEditDocument = (ownerOfDocumentUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleDocumentSidebar,
        vehicleEditRouterSegment,
        ownerOfDocumentUuid,
        uuid
      ],
    },
  }
];
export const vehicleAddDocument = (ownerOfDocumentUuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleDocumentSidebar,
        vehicleAddRouterSegment,
        ownerOfDocumentUuid
      ],
    },
  }
];
export const vehicleDetailsDocument = (uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleDetailsRouterSegment,
        uuid
      ],
    },
  }
];
export const vehicleTransferDocument = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', vehicleManagementRouterSegment, vehicleTransferRouterSegment, uuid],
    },
  }
];

export const vehicleEditFuelCard = (vehicleUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleFuelCardSidebar,
        vehicleEditRouterSegment,
        vehicleUuid,
        uuid
      ],
    },
  }
];
export const vehicleAddFuelCard = (vehicleUuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        vehicleManagementRouterSegment,
        vehicleFuelCardSidebar,
        vehicleAddRouterSegment,
        vehicleUuid
      ],
    },
  }
];

export const budgetManagementUrl = ['/', deliveryRouterSegment, budgetManagementSegment];
export const driverEditDocument = (ownerOfDocumentUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverDocumentSidebar,
        driverEditRouterSegment,
        ownerOfDocumentUuid,
        uuid
      ],
    },
  }
];
export const driverAddDocument = (ownerOfDocumentUuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverDocumentSidebar,
        driverAddRouterSegment,
        ownerOfDocumentUuid
      ],
    },
  }
];
export const driverDetailsDocument = (uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: ['sidebar', deliveryRouterSegment, 's', driverManagementRouterSegment, driverDetailsRouterSegment, uuid],
    },
  }
];

export const namedLocationRouterUrl = ['/', deliveryRouterSegment, namedLocationRouterSegment];
export const namedLocationListRouterUrl = ['/', deliveryRouterSegment, namedLocationRouterSegment, namedLocationListRouterSegment];
export const namedLocationAddRouterUrl = [
  '/',
  deliveryRouterSegment,
  namedLocationRouterSegment,
  namedLocationAddRouterSegment
];

export const namedLocationAddRouterPopupUrl = [
  '/',
  {
    outlets: {
      'popup': [
        'popup',
        deliveryRouterSegment,
        's',
        namedLocationRouterSegment,
        namedLocationAddRouterSegment
      ],
    },
  }
];

export type NamedLocationAddFromExtractionAddress = {
  addressLine?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  city?: string | null;
  country?: string | null;
  postalCode?: string | null;
  state?: string | null;
  pointDTO?: { latitude?: number | null; longitude?: number | null } | null;
};

export type NamedLocationAddFromExtractionPrefill = {
  companyName?: string | null;
  address?: NamedLocationAddFromExtractionAddress | null;
};

export const namedLocationAddFromExtractionRouterPopupUrl = (
  prefill: NamedLocationAddFromExtractionPrefill = {}
) => {
  const matrixParams: Record<string, string> = {};
  if (prefill.companyName) matrixParams['companyName'] = prefill.companyName;

  const a = prefill.address ?? null;
  if (a?.addressLine) matrixParams['addressLine'] = a.addressLine;
  if (a?.streetName) matrixParams['streetName'] = a.streetName;
  if (a?.streetNumber) matrixParams['streetNumber'] = a.streetNumber;
  if (a?.city) matrixParams['city'] = a.city;
  if (a?.country) matrixParams['country'] = a.country;
  if (a?.postalCode) matrixParams['postalCode'] = a.postalCode;
  if (a?.state) matrixParams['state'] = a.state;
  if (a?.pointDTO?.latitude != null) matrixParams['lat'] = String(a.pointDTO.latitude);
  if (a?.pointDTO?.longitude != null) matrixParams['lng'] = String(a.pointDTO.longitude);

  const lastSegment: (string | Record<string, string>)[] = Object.keys(matrixParams).length
    ? [namedLocationAddFromExtractionRouterSegment, matrixParams]
    : [namedLocationAddFromExtractionRouterSegment];

  return [
    '/',
    {
      outlets: {
        'popup': [
          'popup',
          deliveryRouterSegment,
          's',
          namedLocationRouterSegment,
          ...lastSegment,
        ],
      },
    },
  ];
};
export const namedLocationFromTemplateAddRouterUrl = (addressTemplateUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        namedLocationRouterSegment,
        namedLocationAddRouterSegment,
        addressTemplateUuid
      ],
    },
  }
];
export const namedLocationDetailsPopupRouterUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': ['popup-full', deliveryRouterSegment, 's', namedLocationRouterSegment, uuid],
    },
  }
];
export const namedLocationManagementRouterUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  namedLocationRouterSegment,
  namedLocationManagementRouterSegment,
  uuid
];

export const routedOrderTemplateAddRouterUrl = (namedLocationUuid: string) => [
  '/',
  deliveryRouterSegment,
  namedLocationRouterSegment,
  routedOrderTemplateRouterSegment,
  routedOrderTemplateAddRouterSegment,
  namedLocationUuid,
  {
    outlets: {
      'popup-full': null,
    },
  }
];

export const routedOrderTemplateEditRouterUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  namedLocationRouterSegment,
  routedOrderTemplateRouterSegment,
  routedOrderTemplateEditRouterSegment,
  uuid,
  {
    outlets: {
      'popup-full': null,
    },
  }
];

export const ownershipRequestListRouterUrl = ['/', deliveryRouterSegment, ownershipRequestRouterSegment, ownershipRequestListSegment];

export const ownershipRequestAdminListRouterUrl = ['/',deliveryRouterSegment,ownershipRequestRouterSegment,adminOwnershipRequestListSegment]

export const ownershipRequestAddUrl = (uuid : string) => [
  '/',
  deliveryRouterSegment,
  ownershipRequestRouterSegment,
  ownershipRequestAddSegment,
  uuid
];

export const ownershipRequestDetailsUrl = (uuid : string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        ownershipRequestRouterSegment,
        ownershipRequestDetailsSegment,
        uuid
      ],
    },
  }
];

export const operationalTerritoryRouterUrl = ['/', deliveryRouterSegment, operationalTerritoryRouterSegment];
export const driverExpenseRouteUrl = ['/', deliveryRouterSegment, driverExpenseRouterSegment];
export const operationalTerritoryDetailsSidebarRouterUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      sidebar: ['sidebar', deliveryRouterSegment, 's', operationalTerritoryRouterSegment, uuid],
    },
  }
];
export const operationalTerritoryEditRouterUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  operationalTerritoryRouterSegment,
  operationalTerritoryEditRouterSegment,
  uuid
];
export const operationalTerritoryAddRouterUrl = [
  '/',
  deliveryRouterSegment,
  operationalTerritoryRouterSegment,
  operationalTerritoryAddRouterSegment
];

export const warehousesRouterUrl = ['/', deliveryRouterSegment, warehousesRouterSegment];
export const warehousesCreateUrl = ['/', deliveryRouterSegment, warehousesRouterSegment, warehousesCreateRouterSegment];
export const warehousesTerminalsUrl = [
  '/',
  deliveryRouterSegment,
  warehousesRouterSegment,
  warehousesTerminalsRouterSegment
];
export const warehouseReservationListUrl = [
  '/',
  deliveryRouterSegment,
  warehousesRouterSegment,
  warehousesReservationListRouterSegment
]

export const driverAddLicense = (driverUuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverLicensePopup,
        driverAddRouterSegment,
        driverUuid
      ],
    },
  }
];
export const driverEditLicense = (driverUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverLicensePopup,
        driverEditRouterSegment,
        driverUuid,
        uuid
      ],
    },
  }
];
export const driverDetailsLicense = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverLicensePopup,
        driverDetailsRouterSegment,
        uuid
      ],
    },
  }
];

export const cashFlowManagementUrl = ['/', deliveryRouterSegment, cashFlowRouterSegment];
export const cashFlowTransactionsUrl = [
  '/',
  deliveryRouterSegment,
  cashFlowRouterSegment,
  cashFlowTransactionsRouterSegment,
  'list'
];

export const shipmentGroupsUrl = [
  '/',
  deliveryRouterSegment,
  shipmentGroupConsolidationRouterSegment,
  groupsRouterSegment
];

export const driverAddIdentityDocument = (driverUuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverIdentityDocumentPopup,
        driverAddRouterSegment,
        driverUuid
      ],
    },
  }
];
export const driverEditIdentityDocument = (driverUuid: string, uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverIdentityDocumentPopup,
        driverEditRouterSegment,
        driverUuid,
        uuid
      ],
    },
  }
];
export const driverDetailsIdentityDocument = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        driverManagementRouterSegment,
        driverIdentityDocumentPopup,
        driverDetailsRouterSegment,
        uuid
      ],
    },
  }
];

export const blockVendorFormUrl = (uuid: string, status: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', vendorRouterSegment, blockVendorRouterSegment, uuid, status],
    },
  }
];

export const blockCustomerFormUrl = (uuid: string, status: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', customersRouterSegment, blockCustomerRouterSegment, uuid, status],
    },
  }
];

export const customerBlacklistHistoryUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', customersRouterSegment, customerBlacklistHistoryRouterSegment, uuid],
    },
  }
];
export const vendorBlacklistHistoryUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', vendorRouterSegment, vendorBlacklistHistoryRouterSegment, uuid],
    },
  }
];

export const routeShareLocationNewUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', routeShareLocation, routeShareLocationNewRouterSegment, uuid],
    },
  }
];

export const routeShareLocationDetailsUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: ['popup', deliveryRouterSegment, 's', routeShareLocation, routeShareLocationDetailsRouterSegment, uuid],
    },
  }
];

export const sentRouteShareLocationUrl = [
  '/',
  {
    outlets: {
      primary: [deliveryRouterSegment, routeShareLocation, sentRouteShareLocationSegment],
      popup: null,
    },
  }
];

export const transportProjectUrl = ['/', deliveryRouterSegment, transportProjectRouterSegment];
export const collaborationShipmentsProjectUrl = [
  '/',
  deliveryRouterSegment,
  transportProjectRouterSegment,
  transportProjectScheduledRouterSegment
];

export const transportProjectAdd = [...transportProjectUrl, transportProjectAddRouterSegment];

export const transportProjectEdit = (uuid: string) => [...transportProjectUrl, transportProjectEditRouterSegment, uuid];

export const scheduledShipmentNewUrl = [
  '/',
  deliveryRouterSegment,
  scheduledShipmentsRouterSegment,
  scheduledShipmentRouterSegment,
  newRouterSegment
];
export const scheduledShipmentEditUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  scheduledShipmentsRouterSegment,
  scheduledShipmentRouterSegment,
  editRouterSegment,
  uuid
];
export const scheduledShipmentFromTemplateUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  scheduledShipmentsRouterSegment,
  scheduledShipmentRouterSegment,
  fromTemplateRouterSegment,
  uuid
];
export const shipmentTemplateNewUrl = [
  '/',
  deliveryRouterSegment,
  scheduledShipmentsRouterSegment,
  shipmentTemplateRouterSegment,
  newRouterSegment
];
export const shipmentTemplateEditUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  scheduledShipmentsRouterSegment,
  shipmentTemplateRouterSegment,
  editRouterSegment,
  uuid
];

export const eTransportIntegrationEditPopupUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        etransportEditRouterSegment,
        uuid
      ],
    },
  }
];

export const eTransportIntegrationAddPopupUrl = (shipmentUuid: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        etransportAddRouterSegment,
        shipmentUuid
      ],
    },
  }
];

export const eTransportModifVehiclePopupUrl = (uit: string) => [
  '/',
  {
    outlets: {
      'popup-full': [
        'popup-full',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        etransportModifVehicleRouterSegment,
        uit
      ],
    },
  }
];

export const eTransportListPageUrl = ['/', deliveryRouterSegment, etransportRouterSegment, etransportListRouterSegment];
export const eTransportShipmentOrganizerListPageUrl = [
  '/',
  deliveryRouterSegment,
  etransportRouterSegment,
  eTransportOrganizerRouterSegment,
  etransportListRouterSegment
];
export const eTransportAnafMessagesListPageUrl = [
  '/',
  deliveryRouterSegment,
  etransportRouterSegment,
  eTransportDeclarantRouterSegment,
  etransportListRouterSegment
];
export const eTransportActionsListPageUrl = [
  '/',
  deliveryRouterSegment,
  etransportActionsRouterSegment,
  etransportActionsListRouterSegment
];
export const eTransportAddPageUrl = ['/', deliveryRouterSegment, etransportRouterSegment, etransportAddRouterSegment];
export const eTransportDuplicatePageUrl = (notificationUuid: string) => [
  '/',
  deliveryRouterSegment,
  etransportRouterSegment,
  etransportDuplicateRouterSegment,
  notificationUuid
];
export const eTransportDetailsPageUrl = (notificationUuid: string) => [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        etransportDetailsRouterSegment,
        notificationUuid
      ],
    },
  }
];

export const eTransportShipmentOrganizerModifiedVehiclesUrl = [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        eTransportOrganizerRouterSegment,
        'modified-vehicles'
      ],
    },
  }
];

export const eTransportShipmentDeclarantModifiedVehiclesMessagesAndMessagesUrl = [
  '/',
  {
    outlets: {
      sidebar: [
        'sidebar',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        eTransportDeclarantRouterSegment,
        'modified-vehicles-messages-and-messages'
      ],
    },
  }
];

export const eTransportConfirmationPopupUrl = (notificationUuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        etransportRouterSegment,
        eTransportConfirmationRouterSegment,
        notificationUuid
      ],
    },
  }
];

export const addVendorUrl = ['/', deliveryRouterSegment, vendorRouterSegment, newRouterSegment];

export const addDriverUrl = [
  '/',
  deliveryRouterSegment,
  driverManagementRouterSegment,
  newRouterSegment,
  driverDetailsRouterSegment
];

export const addVehicleUrl = [
  '/',
  deliveryRouterSegment,
  vehicleManagementRouterSegment,
  newRouterSegment,
  driverDetailsRouterSegment
];

export const externalMappingsUrl = ['/', deliveryRouterSegment, externalMappingsRouterSegment];

export const externalMappingsLocationAddUrl = [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsLocationRouterSegment
      ],
    },
  }
];

export const externalMappingsLocationEditUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsEditRouterSegment,
        externalMappingsLocationRouterSegment,
        uuid
      ],
    },
  }
];

export const externalMappingsLocationAddInternalRefUrl = (internalRef: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsLocationRouterSegment,
        internalRef
      ],
    },
  }
];

export const externalMappingsPackageAddUrl = [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsPackageRouterSegment
      ],
    },
  }
];

export const externalMappingsPackageEditUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsEditRouterSegment,
        externalMappingsPackageRouterSegment,
        uuid
      ],
    },
  }
];

export const externalMappingsPackageAddInternalRefUrl = (internalRef: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsPackageRouterSegment,
        internalRef
      ],
    },
  }
];

export const externalMappingsLegalEntityAddUrl = [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsLegalEntityRouterSegment
      ],
    },
  }
];

export const externalMappingsLegalEntityEditUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsEditRouterSegment,
        externalMappingsLegalEntityRouterSegment,
        uuid
      ],
    },
  }
];

export const externalMappingsLegalEntityAddInternalRefUrl = (internalRef: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsLegalEntityRouterSegment,
        internalRef
      ],
    },
  }
];

export const externalMappingsHubLocationAddUrl = [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsHubLocationRouterSegment
      ],
    },
  }
];

export const externalMappingsHubLocationEditUrl = (uuid: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsEditRouterSegment,
        externalMappingsHubLocationRouterSegment,
        uuid
      ],
    },
  }
];

export const externalMappingsHubLocationAddInternalRefUrl = (internalRef: string) => [
  '/',
  {
    outlets: {
      popup: [
        'popup',
        deliveryRouterSegment,
        's',
        externalMappingsRouterSegment,
        externalMappingsAddRouterSegment,
        externalMappingsHubLocationRouterSegment,
        internalRef
      ],
    },
  }
];

export const unEdifactListUrl = ['/', deliveryRouterSegment, unedifactRouterSegment, unedifactListRouterSegment];

export const unEdifactDetailsUrl = (uuid: string) => ['/', deliveryRouterSegment, unedifactRouterSegment, uuid];

export const driverTimesheetUrl = ['/', deliveryRouterSegment, driverTimesheetRouterSegment];

export const courierManagementUrl = ['/', deliveryRouterSegment, courierManagementRouterSegment]

export const courierAddFromPopup: (string | { outlets: { popup: string[] } })[] =
  ['/', { outlets: { 'popup': ['popup', deliveryRouterSegment, 's', courierManagementRouterSegment, 'new'] } }]

export const courierEditFromPopup = (uuid: string) =>
  ['/', { outlets: { 'popup': ['popup', deliveryRouterSegment, 's', courierManagementRouterSegment, courierEditRouterSegment, uuid] } }]

export const externalVendorAccountNumberAdd: (string | { outlets: { popup: string[] } })[] =
  ['/', { outlets: { 'popup': ['popup', deliveryRouterSegment, 's', courierManagementRouterSegment, externalVendorAccountNumberRouterSegment, externalVendorAccountNumberNewRouterSegment] } }]

export const externalVendorDiscountAdd =
  ['/', { outlets: { 'popup': ['popup', deliveryRouterSegment, 's', courierManagementRouterSegment, externalVendorDiscountRouterSegment, externalVendorDiscountNewRouterSegment] } }]

export const orderShipperAndPaymentPartiesPopup: (offerUuid: string) => (string | { outlets: { popup: string[] } })[] = (offerUuid: string) =>
  ['/', { outlets: { 'popup': ['popup', deliveryRouterSegment, 's', 'courier', orderShipperAndPaymentPartiesManagementUrl, offerUuid] } }]

export const nomenclatureListRouterUrl = ['/', deliveryRouterSegment, nomenclatureRouterSegment, nomenclatureListRouterSegment];
export const nomenclatureAddRouterUrl = ['/', deliveryRouterSegment, nomenclatureRouterSegment, nomenclatureAddRouterSegment];
export const nomenclatureEditRouterUrl = (uuid: string) => [
  '/',
  deliveryRouterSegment,
  nomenclatureRouterSegment,
  nomenclatureEditRouterSegment,
  uuid
];

export const supplierDelegationManagementUrl = ['/', deliveryRouterSegment, supplierDelegationRouterSegment]

export const hubRoutingRouterUrl = ['/', deliveryRouterSegment, namedLocationRouterSegment, hubRoutingRouterSegment];
